import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import Chip from '../common/chip'
import { Payment } from '../../types'
import MoneyGreenIcon from '../../assets/icons/money-icon-green.svg'
import TicketIcon from '../../assets/icons/ticket-icon.svg'
import { numberWithCommas } from '../../utils/common.utils'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

const CustomerDetailsPaymentsListItem = ({ paymentData, handleOpenPaymentDetailsModal }: { paymentData: Partial<Payment>; handleOpenPaymentDetailsModal: (selectedPaymentData: Partial<Payment>) => void }) => {
  const { t } = useTranslation(['customer-details-management'])

  return (
    <div
      onClick={() => handleOpenPaymentDetailsModal(paymentData)}
      className="customer-details-list-item-data-container"
    >
      <div className="customer-details-list-item-left-data">
        <div className="customer-details-list-item-left-subdata">
          <div className="customer-details-list-item-icon">
            <img
              src={CalendarIcon}
              alt="calendar-icon"
            />
          </div>
          <div className="customer-details-list-item-text">{paymentData.createdAt ? format(paymentData.createdAt, 'dd/MM/yyyy') : ''}</div>
        </div>
        <div className="customer-details-list-item-right-subdata">
          <div className="customer-details-list-item-icon">
            <img
              src={MoneyGreenIcon}
              alt="money-icon"
            />
          </div>
          <div className="customer-details-list-item-text">
            {numberWithCommas(Number(paymentData.amount))} {paymentData.currency?.toUpperCase() || 'COP'}
          </div>
        </div>
      </div>
      <div className="customer-details-list-item-right-data">
        <div className="customer-details-list-item-left-subdata">
          <div className="customer-details-list-item-icon">
            <img
              src={TicketIcon}
              alt="ticket-icon"
            />
          </div>
          <div className="customer-details-list-item-text">{paymentData.referenceNumber}</div>
        </div>
        <div className="customer-details-list-item-right-subdata">
          <div className="customer-details-list-item-chip-container">
            <Chip
              status={paymentData.status ?? 'reviewed'}
              label={
                paymentData?.status === 'reviewed'
                  ? t('customerDetailsPaymentsListItem.statusTexts.reviewed')
                  : paymentData?.status?.indexOf('error') !== -1
                  ? t('customerDetailsPaymentsListItem.statusTexts.error')
                  : paymentData?.status === 'paid'
                  ? t('customerDetailsPaymentsListItem.statusTexts.paid')
                  : paymentData?.status === 'validated'
                  ? t('customerDetailsPaymentsListItem.statusTexts.validated')
                  : paymentData?.status === 'returned'
                  ? t('customerDetailsPaymentsListItem.statusTexts.returned')
                  : paymentData?.status === 'rejected'
                  ? t('customerDetailsPaymentsListItem.statusTexts.rejected')
                  : t('customerDetailsPaymentsListItem.statusTexts.forReview')
              }
            />
          </div>
          <div className="customer-details-list-item-arrow-right">
            <img
              src={ArrowRightIcon}
              alt="arrow-right-icon"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerDetailsPaymentsListItem
